/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
import { environment } from '../environments/environment';
import { AuthError } from '@fry/lib/auth/errors';
import { SERVER_CONFIG, ConfigService } from '@fry/lib/config';
import { BOARD_CARD_TYPE } from '@fry/boards/lib';
import { ProfileCard } from '@fry/components/users/cards/profile.card';
import { TextCard } from '@fry/components/common/text-card/text-card';
import { WalkthroughsCard } from '@fry/walkthroughs/components/walkthroughs-card';
import { BookingTableCard } from '@fry/booking/components/bookings/booking-table-card/booking-table.card';
import { BookingAvailableCard } from '@fry/booking/components/bookings/booking-available-card/booking-available-card';

if (environment.production) {
  enableProdMode();
}

// Fade out and remove the boot overlay defined in index.html once Angular bootstraps.
function hideLoader(): void {
  const loader = window.document.getElementById('app-loader');
  if (!loader) { return; }
  loader.classList.add('app-loader--hide');
  setTimeout(() => loader.remove(), 400);
}

// Swap the loading content for an error message and keep the overlay up.
function showError(error: Error | string): void {
  console.error(error);
  const loadingMsg = window.document.getElementById('app-loading-msg');
  const spinner = window.document.querySelector<HTMLElement>('.pinwheel-loading__container');
  const errorBox = window.document.getElementById('app-error');
  const errorDetails = window.document.getElementById('app-error-details');
  if (loadingMsg) { loadingMsg.style.display = 'none'; }
  if (spinner) { spinner.style.display = 'none'; }
  if (errorBox) { errorBox.style.display = 'block'; }
  if (errorDetails) {
    errorDetails.textContent = error instanceof Error ? error.message : error;
  }

  const reloadBtn = window.document.getElementById('app-reload-btn');
  if (reloadBtn) { reloadBtn.addEventListener('click', () => window.location.reload()); }
}

fetch('__config__')
.then(response => response.json())
.then(config => {
  try {
    const payload = JSON.stringify(config);
    localStorage.setItem(ConfigService.CONFIG_STORAGE_KEY, payload);
  } catch (err) {
    console.log('Failed storing server config in local storage');
  }
  console.log('Config loaded');
  return config;
})
.catch(err => {
  console.log('Could not fetch server config, attempting local storage', err);
  let config;
  try {
    const data = localStorage.getItem(ConfigService.CONFIG_STORAGE_KEY);
    config = JSON.parse(data ?? '');
  } catch(err) {
    console.log('Failed loading from local storage', err);
    config = {}
  }
  return config;
})
.then(config => {
  window["kzConfig"] = config;
  console.log('Bootstraping angular')
  platformBrowserDynamic([
    {provide: SERVER_CONFIG, useValue: config},
    {provide: BOARD_CARD_TYPE, multi: true, useValue: ProfileCard},
    {provide: BOARD_CARD_TYPE, multi: true, useValue: TextCard},
    {provide: BOARD_CARD_TYPE, multi: true, useValue: WalkthroughsCard},
    {provide: BOARD_CARD_TYPE, multi: true, useValue: BookingTableCard},
    {provide: BOARD_CARD_TYPE, multi: true, useValue: BookingAvailableCard},
  ]).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
                          .then(() => hideLoader())
                          .catch((error: Error|string) => {
                            // Ignore authentication errors, OIDC will handle it!
                            // Keep the loader visible while the OIDC redirect happens.
                            if (error instanceof AuthError) {
                              console.log(error.message);
                              return;
                            }

                            showError(error);
                          });

});
